import * as React from "react";
import { Context } from "./_context";
export const PasskeyIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.611 3.611a5.5 5.5 0 1 1 .772 8.42l-2.97 2.968 2.794 2.794-1.414 1.414-2.794-2.794-1.586 1.586 1.794 1.794-1.414 1.414-1.794-1.794-1.792 1.794-1.414-1.414 9.176-9.177a5.5 5.5 0 0 1 .642-7.005Zm6.363 1.414a3.5 3.5 0 1 0-4.949 4.95 3.5 3.5 0 0 0 4.95-4.95Z", fill: "currentColor" }));
  return iconset[size];
};
PasskeyIcon.iconId = "oQ5gWh";
